import { Link as RouterLink, LinkProps } from 'react-router';

interface CustomLinkProps extends LinkProps {
  resetScroll?: boolean; // Prop opsional untuk mengontrol reset scroll
}

export default function Link({ to, children, resetScroll = true, ...props }: CustomLinkProps) {
  const handleClick = () => {
    if (resetScroll) {
      window.scrollTo(0, 0);
    }
  };

  return (
    <RouterLink to={to} onClick={handleClick} {...props}>
      {children}
    </RouterLink>
  );
}
